module.exports = __webpack_public_path__ + "static/img/vr_hy_v2_max.479dc006.png";